import React, { useState, useRef } from "react";
import Carousel from "react-bootstrap/Carousel";
import ArrowLeft from '../../assets/icons/arrow-left.svg';
import './slide.css'


const SliderWeb = ({ bannerImg }) => {
  const carouselRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const [lastMoveTime, setLastMoveTime] = useState(0);

  // برای جلوگیری از فراخوانی بیش از حد در هر حرکت موس
  const throttle = (func, delay) => {
    let lastCall = 0;
    return (...args) => {
      const now = Date.now();
      if (now - lastCall >= delay) {
        lastCall = now;
        func(...args);
      }
    };
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const handleMouseMove = throttle((e) => {
    if (!isDragging) return;

    setCurrentX(e.clientX);
  }, 16); // مقدار 16ms برای استفاده از throttle و جلوگیری از فراخوانی زیاد تابع

  const handleMouseUp = () => {
    setIsDragging(false);
    const deltaX = currentX - startX;

    if (deltaX > 50) {
      carouselRef.current?.prev(); // اسلاید قبلی
    } else if (deltaX < -50) {
      carouselRef.current?.next(); // اسلاید بعدی
    }

    // ریست مقادیر
    setStartX(0);
    setCurrentX(0);
  };

  // جلوگیری از تغییر اسلاید هنگام کلیک روی دکمه‌ها
  const handleButtonClick = (e) => {
    e.stopPropagation(); // جلوگیری از پراپگیشن رویداد
  };

  return (
    <>
     <div
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={() => setIsDragging(false)}
      className=""
      style={{ cursor: isDragging ? "grabbing" : "grab" }}
    >
      <Carousel
        ref={carouselRef}
        interval={10000}
        controls={false}
        indicators={bannerImg.length > 1}
      >
        {bannerImg
          .map((item, index) => (
            <Carousel.Item key={`${item.si}-${index}`}>

              <img
                src={item.Pic}
                className="img-slider"
                alt=""
                draggable={false}
              />
              <Carousel.Caption>
                {/* <div className='banner-card'>
                  <h1 className='mt-5'>طبیعی باش ...</h1>
                  <h5 className='mt-4'>کیفیت محصولات ما، راز موفقیت ماست</h5>
                  <button className='btn btn-outline-primary mt-4 mb-5 d-flex'>مشاهده محصولات <img src={ArrowLeft} alt="" /></button>
                </div> */}
              </Carousel.Caption>
            </Carousel.Item>
          ))}
      </Carousel>
    </div>
    </>
   
  );
};

export default SliderWeb;

